<template>
  <div>
    <form-step
      :checked="checked" :validated="validated"
      :onSubmit="onSubmit" stepName="Product"
      @check="$emit('check', true)"
      @edit="$emit('check', false)"
      @nextStep="$emit('next')">
      <template #title>What is the product or service provided?</template>
      <template #form>
        <input type="text" class="form-control" placeholder="e.g. accounting" :value="value" @input="$emit('input', $event.target.value)">
      </template>
      <template #billboard>
      <!-- alert success -->
        <div class="row justify-content-center">
          <h1 class="mb-4 mx-5"><icon icon="check-circle" class="text-success mr-2" /></h1>
          <h2 class="mb-4 mx-5">We can cover that!</h2>
        </div>
        <!-- explanatory cards -->
        <div class="card-deck ">
            <!-- first card -->
            <div class="card shadow border-0">
              <img class="card-img-top" src="@/assets/img/product-transit.svg" alt="date invoice">
              <div class="card-body">
                <div class="row no-gutters pt-4">
                    <div class="card-block pl-1 pr-2">
                        <h3 class="card-text mb-3 ml-4 text-muted">Careful with delivery</h3>
                        <p class="card-text mb-3 ml-4 text-muted">Damage or loss of goods in transit is not covered and your customer could dispute the validity of the invoice.</p>
                    </div>
                </div>
              </div>
            </div>
          <div class="w-100 d-none d-sm-block d-md-none mb-4"><!-- wrap every 2 on sm--></div>
          <!-- second card -->
          <div class="card shadow border-0">
          <img class="card-img-top" src="@/assets/img/product-government.svg" alt="product government">
            <div class="card-body">
                <div class="row no-gutters pt-4">
                  <div class="card-block pl-1 pr-2">
                      <h3 class="card-text mb-3 ml-4 text-muted">Government activities</h3>
                      <p class="card-text mb-3 ml-4 text-muted"> We don't cover activities by a government, such as war or currency control, which prevent your invoice from being paid</p>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </template>
    </form-step>
  </div>
</template>

<script>
import FormStep from '@/components/FormStep'

export default {
  name: 'product',
  components: {
    FormStep
  },
  props: {
    checked: Boolean,
    validated: Boolean,
    onSubmit: Function,
    value: {}
  }
}
</script>
